export default "__VITE_ASSET__C9MzzxJc__"